/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseListItemViewModel } from "../types/CourseListItemViewModel.ts";
import { eCourseModalitySchema } from "./eCourseModalitySchema.ts";
import { eCourseStatusSchema } from "./eCourseStatusSchema.ts";

export const courseListItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do curso.")),
  code: z.string().describe("Código do curso, único por empresa.").nullish(),
  nameOfficial: z
    .string()
    .describe(
      "Nome oficial no idioma corrente, com fallback para o primeiro idioma cadastrado.",
    )
    .nullish(),
  status: z.optional(
    z
      .lazy(() => eCourseStatusSchema)
      .describe("1 = Released | 2 = Canceled | 3 = Finalized | "),
  ),
  statusName: z
    .string()
    .describe("Descrição da situação do curso (pt-BR).")
    .nullish(),
  modality: z.optional(
    z
      .lazy(() => eCourseModalitySchema)
      .describe(
        "1 = Distance | 2 = Presential | 3 = SemiClassroom | 4 = OnDemand | ",
      ),
  ),
  modalityName: z
    .string()
    .describe("Descrição da modalidade do curso (pt-BR).")
    .nullish(),
  companyId: z
    .number()
    .int()
    .describe(
      "ID da empresa dona do curso. Nulo quando o curso é da matriz. Opcional.",
    )
    .nullish(),
  companyName: z
    .string()
    .describe(
      "Nome da empresa dona do curso. Vazio quando o curso é da matriz.",
    )
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se o curso está ativo.")),
  openCourse: z.optional(z.boolean().describe("Indica se o curso é aberto.")),
  showInLogin: z.optional(
    z.boolean().describe("Indica se o curso é destacado na tela de login."),
  ),
  requiredApproval: z.optional(
    z.boolean().describe("Indica se o curso exige aprovação de documentação."),
  ),
  automaticApproval: z.optional(
    z
      .boolean()
      .describe("Indica se o curso possui aprovação automática de matrícula."),
  ),
  hasMonograph: z.optional(
    z.boolean().describe("Indica se o curso possui monografia."),
  ),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração. Opcional.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração. Opcional.")
    .nullish(),
}) as unknown as ToZod<CourseListItemViewModel>;
